import {AnnotationTool} from 'substance'
import {DWAnnotationCommand} from '../../../../../lib/commands/DWAnnotationCommand'

import {StrongNode} from './nodes/StrongNode'
import {StrongConverter} from './converters/StrongConverter'
import {StrongComponent} from './StrongComponent'

import './scss/strong.scss'

const StrongPackage = {
    name: 'strong',
    configure: function(configurator, {toolGroup, disableCollapsedCursor}) {

        configurator.addNode(StrongNode)
        configurator.addConverter(StrongConverter)

        configurator.addComponent('strong', StrongComponent)

        configurator.addCommand('strong', DWAnnotationCommand, {
            nodeType: StrongNode.type,
            disableCollapsedCursor
        })
        configurator.addTool('strong', AnnotationTool, {
            toolGroup: toolGroup || 'annotations'
        })

        configurator.addIcon('strong', {'fontawesome': 'fa-bold'})
        configurator.addLabel('strong', {
            en: 'Strong',
            de: 'Fett'
        })

        const combos = {
            standard: {
                'default': 'ctrl+b',
                'mac': 'cmd+b'
            }
        }

        configurator.addKeyboardShortcut(combos, {command: 'strong'}, false, configurator.getLabelProvider().getLabel(this.name))
    }
}

export {StrongPackage}
